import { Divider } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { PackageManagerIcon } from "@/icons"
import styles from "./PackageManagersList.module.scss"
import { PackageManagersProps } from "./PackageManagersProps.types"

export const PackageManagersList = ({
  packageManagers = []
}: PackageManagersProps) => {
  const { t } = useTranslation("translation", { keyPrefix: "packageManagers" })

  return (
    <div className={styles.container}>
      {!packageManagers?.length && "-"}
      {packageManagers.map((manager, index) => (
        <span key={index} className={styles.wrapper}>
          <div className={styles.packageManagerPill}>
            <PackageManagerIcon packageManager={manager} />
            {t(manager)}
          </div>
          {index < packageManagers.length - 1 && (
            <Divider orientation="vertical" />
          )}
        </span>
      ))}
    </div>
  )
}
